module.exports = "/static/assets/72274ca26f833068c02a472e0411ddbf.png";